import { render, staticRenderFns } from "./ColorFamilyPicker.vue?vue&type=template&id=57270c72"
import script from "./ColorFamilyPicker.vue?vue&type=script&lang=ts"
export * from "./ColorFamilyPicker.vue?vue&type=script&lang=ts"
import style0 from "./ColorFamilyPicker.vue?vue&type=style&index=0&id=57270c72&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports